import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { ToastProvider } from './components/Toast';
import { setTokenGetter } from './marketingApi';
import './marketing.css';

// Hosts the ported marketing pages inside the unified shell.
// The .mkt class scopes the legacy marketing stylesheet to this subtree.
export default function MarketingLayout() {
  const { getToken } = useAuth();
  useEffect(() => { setTokenGetter(getToken); }, [getToken]);
  return (
    <main className="main-content ops-main mkt">
      <div className="ops-page">
        <ToastProvider>
          <Outlet />
        </ToastProvider>
      </div>
    </main>
  );
}
